/**

 * Canonical permission codes — keep in sync with SQL seed (Scripts/Add_Rbac_Tables_AndSeed.sql)

 * and JWT "perm" claims issued at login.

 */

export const P = {
  PAGE_DASHBOARD: 'PAGE_DASHBOARD',

  PAGE_BOOKINGS: 'PAGE_BOOKINGS',

  PAGE_CREATE_ORDER: 'PAGE_CREATE_ORDER',

  PAGE_ORDERS: 'PAGE_ORDERS',

  PAGE_TABLE_ORDERS: 'PAGE_TABLE_ORDERS',

  PAGE_PAYMENTS: 'PAGE_PAYMENTS',

  PAGE_INVOICE: 'PAGE_INVOICE',

  PAGE_REPORTS: 'PAGE_REPORTS',

  PAGE_SETTINGS: 'PAGE_SETTINGS',

  PAGE_USER_MANAGEMENT: 'PAGE_USER_MANAGEMENT',

  DASHBOARD_VIEW_REVENUE: 'DASHBOARD_VIEW_REVENUE',

  DASHBOARD_VIEW_TOTAL_SALES: 'DASHBOARD_VIEW_TOTAL_SALES',

  DASHBOARD_VIEW_OCCUPANCY: 'DASHBOARD_VIEW_OCCUPANCY',

  DASHBOARD_VIEW_CHECKINS: 'DASHBOARD_VIEW_CHECKINS',

  DASHBOARD_VIEW_CHECKOUTS: 'DASHBOARD_VIEW_CHECKOUTS',

  DASHBOARD_VIEW_RESTAURANT_REVENUE: 'DASHBOARD_VIEW_RESTAURANT_REVENUE',

  DASHBOARD_VIEW_ADDON_REVENUE: 'DASHBOARD_VIEW_ADDON_REVENUE',

  DASHBOARD_VIEW_ANALYTICS_CHARTS: 'DASHBOARD_VIEW_ANALYTICS_CHARTS',

  DASHBOARD_VIEW_AVAILABLE_ROOMS: 'DASHBOARD_VIEW_AVAILABLE_ROOMS',

  DASHBOARD_VIEW_PENDING_INVOICES: 'DASHBOARD_VIEW_PENDING_INVOICES',

  DASHBOARD_VIEW_MONTHLY_REVENUE: 'DASHBOARD_VIEW_MONTHLY_REVENUE',

  DASHBOARD_VIEW_TODAY_REVENUE: 'DASHBOARD_VIEW_TODAY_REVENUE',

  DASHBOARD_VIEW_NET_CASH: 'DASHBOARD_VIEW_NET_CASH',

  BOOKING_VIEW: 'BOOKING_VIEW',

  BOOKING_CREATE: 'BOOKING_CREATE',

  BOOKING_EDIT: 'BOOKING_EDIT',

  BOOKING_DELETE: 'BOOKING_DELETE',

  BOOKING_MANAGE: 'BOOKING_MANAGE',

  BOOKING_ADD_PAYMENT: 'BOOKING_ADD_PAYMENT',

  BOOKING_VIEW_PAYMENT: 'BOOKING_VIEW_PAYMENT',

  BOOKING_VIEW_DETAILS: 'BOOKING_VIEW_DETAILS',

  BOOKING_ADD_COVER_CHARGE: 'BOOKING_ADD_COVER_CHARGE',

  BOOKING_DISCOUNT: 'BOOKING_DISCOUNT',

  BOOKING_ADD_DISCOUNT: 'BOOKING_ADD_DISCOUNT',

  BOOKING_MANAGE_ADDONS: 'BOOKING_MANAGE_ADDONS',

  BOOKING_GENERATE_INVOICE: 'BOOKING_GENERATE_INVOICE',

  BOOKING_PREVIEW_INVOICE: 'BOOKING_PREVIEW_INVOICE',

  BOOKING_CHECKIN: 'BOOKING_CHECKIN',

  BOOKING_CHECKOUT: 'BOOKING_CHECKOUT',

  BOOKING_CANCEL: 'BOOKING_CANCEL',

  ORDER_VIEW: 'ORDER_VIEW',

  ORDER_CREATE: 'ORDER_CREATE',

  ORDER_EDIT: 'ORDER_EDIT',

  ORDER_CANCEL: 'ORDER_CANCEL',

  ORDER_DISCOUNT: 'ORDER_DISCOUNT',

  ORDER_ADD_DISCOUNT: 'ORDER_DISCOUNT',

  TABLE_ORDER_VIEW: 'TABLE_ORDER_VIEW',

  TABLE_ORDER_CREATE: 'TABLE_ORDER_CREATE',

  TABLE_ORDER_DISCOUNT: 'TABLE_ORDER_DISCOUNT',

  TABLE_ORDER_ADD_DISCOUNT: 'TABLE_ORDER_DISCOUNT',

  TABLE_ORDER_MERGE_TABLE: 'TABLE_ORDER_MERGE_TABLE',

  TABLE_ORDER_MERGE_TABLES: 'TABLE_ORDER_MERGE_TABLE',

  TABLE_ORDER_SPLIT_BILL: 'TABLE_ORDER_SPLIT_BILL',

  ORDER_ADD_PAYMENT: 'ORDER_ADD_PAYMENT',

  ORDER_PRINT_BILL: 'ORDER_PRINT_BILL',

  TABLE_ORDER_PRINT_BILL: 'TABLE_ORDER_PRINT_BILL',

  TABLE_ORDER_MARK_PAID: 'TABLE_ORDER_MARK_PAID',

  TABLE_ORDER_GENERATE_KOT: 'TABLE_ORDER_GENERATE_KOT',

  USER_MANAGE_RBAC: 'USER_MANAGE_RBAC',

  // ---- Spa POS ----
  PAGE_SPA: 'PAGE_SPA',
  SPA_SERVICE_MANAGE: 'SPA_SERVICE_MANAGE',
  SPA_THERAPIST_MANAGE: 'SPA_THERAPIST_MANAGE',
  SPA_BOOKING_VIEW: 'SPA_BOOKING_VIEW',
  SPA_BOOKING_CREATE: 'SPA_BOOKING_CREATE',
  SPA_BOOKING_CANCEL: 'SPA_BOOKING_CANCEL',
  SPA_PAYMENT_ADD: 'SPA_PAYMENT_ADD',
  SPA_INVOICE_GENERATE: 'SPA_INVOICE_GENERATE',
  SPA_REFUND: 'SPA_REFUND',

  // ---- Laundry POS ----
  PAGE_LAUNDRY: 'PAGE_LAUNDRY',
  LAUNDRY_ITEM_MANAGE: 'LAUNDRY_ITEM_MANAGE',
  LAUNDRY_ORDER_VIEW: 'LAUNDRY_ORDER_VIEW',
  LAUNDRY_ORDER_CREATE: 'LAUNDRY_ORDER_CREATE',
  LAUNDRY_ORDER_STATUS_CHANGE: 'LAUNDRY_ORDER_STATUS_CHANGE',
  LAUNDRY_ORDER_CANCEL: 'LAUNDRY_ORDER_CANCEL',

  // ---- Mini-Bar POS ----
  PAGE_MINIBAR: 'PAGE_MINIBAR',
  MINIBAR_ITEM_MANAGE: 'MINIBAR_ITEM_MANAGE',
  MINIBAR_ASSIGNMENT_MANAGE: 'MINIBAR_ASSIGNMENT_MANAGE',
  MINIBAR_CONSUMPTION_RECORD: 'MINIBAR_CONSUMPTION_RECORD',
  MINIBAR_CONSUMPTION_ADJUST: 'MINIBAR_CONSUMPTION_ADJUST',
  MINIBAR_REPLENISH: 'MINIBAR_REPLENISH',

  // ---- Housekeeping ----
  PAGE_HOUSEKEEPING: 'PAGE_HOUSEKEEPING',
  HK_STAFF_MANAGE: 'HK_STAFF_MANAGE',
  HK_TASK_VIEW: 'HK_TASK_VIEW',
  HK_TASK_CREATE: 'HK_TASK_CREATE',
  HK_TASK_STATUS_CHANGE: 'HK_TASK_STATUS_CHANGE',
  HK_TASK_VERIFY: 'HK_TASK_VERIFY',
  HK_ROOM_STATUS_UPDATE: 'HK_ROOM_STATUS_UPDATE',
  HK_MAINTENANCE_RAISE: 'HK_MAINTENANCE_RAISE',
  HK_MAINTENANCE_RESOLVE: 'HK_MAINTENANCE_RESOLVE',
};

/** Sidebar menuKey → RBAC page code (when granular RBAC is active). */

export const MENU_RBAC = {
  dashboard: P.PAGE_DASHBOARD,

  BookingReport: P.PAGE_BOOKINGS,

  manageinventory: P.PAGE_BOOKINGS,

  HoldRoom: P.PAGE_BOOKINGS,

  Changeroom: P.PAGE_BOOKINGS,

  Calender: P.PAGE_BOOKINGS,

  Paymentreport: P.PAGE_REPORTS,

  Bookingfilter: P.PAGE_REPORTS,

  InvoiceReport: P.PAGE_REPORTS,

  Guestreport: P.PAGE_REPORTS,

  Holdreport: P.PAGE_REPORTS,

  CreateOrder: P.PAGE_CREATE_ORDER,

  Order: P.PAGE_ORDERS,

  RestaurantOrder: P.PAGE_TABLE_ORDERS,

  CreateUser: P.PAGE_USER_MANAGEMENT,

  UserPermission: P.PAGE_USER_MANAGEMENT,

  PettyCashManagement: P.PAGE_PAYMENTS,

  // Spa POS
  'Spa/Services': P.PAGE_SPA,
  'Spa/Therapists': P.PAGE_SPA,
  'Spa/Bookings': P.PAGE_SPA,

  // Laundry POS
  'Laundry/Items': P.PAGE_LAUNDRY,
  'Laundry/Orders': P.PAGE_LAUNDRY,

  // Mini-Bar POS
  'MiniBar/Items': P.PAGE_MINIBAR,
  'MiniBar/Consumption': P.PAGE_MINIBAR,

  // Housekeeping
  'Housekeeping/Dashboard': P.PAGE_HOUSEKEEPING,
  'Housekeeping/Tasks': P.PAGE_HOUSEKEEPING,
  'Housekeeping/Staff': P.PAGE_HOUSEKEEPING,
};
